import Image from 'next/image';
import router from 'next/router';
import ReactMarkdown from 'react-markdown';
import { RequestCallToActionStyle } from '../../styles/components/country';
import { Button } from '../common/ui';

export interface IRequestCallToActionProps {
  text: string;
  fromPrice: string;
  fromLabel?: string;
  feesIncludedLabel: string;
  button: { text: string; link?: string; action?: () => void | Promise<void> };
}

const RequestCallToAction = (props: IRequestCallToActionProps) => {
  return (
    <div className={RequestCallToActionStyle['request-call-to-action']}>
      <div className={RequestCallToActionStyle['request-call-to-action-text']}>
        <ReactMarkdown>{props.text}</ReactMarkdown>
      </div>
      <div
        className={
          RequestCallToActionStyle['request-call-to-action-button-wrapper']
        }>
        <div
          className={RequestCallToActionStyle['request-call-to-action-button']}>
          <div
            className={
              RequestCallToActionStyle['request-call-to-action-button-heading']
            }>
            <p>
              {props.fromLabel} <span>{props.fromPrice}</span>
            </p>
            <p>{props.feesIncludedLabel}</p>
          </div>
          <Button
            color={'cta-primary'}
            hasIcon={true}
            onClick={() => {
              if (props.button.link) {
                router.push(props.button.link);
              }

              if (props.button.action) {
                props.button.action();
              }
            }}>
            {props.button.text}
            <Image
              quality={90}
              src={'/assets/images/icons/ChevronRightWhite.svg'}
              alt={'action-button'}
              width={16}
              height={16}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RequestCallToAction;
